import { Data } from '.generated/Foundation.CW.model';
import {
  ComponentRendering,
  LinkField,
  useSitecoreContext,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import useDictionary from 'lib/hooks/useDictionary';
import { TransformedSiteSettings } from 'lib/page-props-factory/plugins/site-settings';
import Link from 'next/link';

export type BlogTagsProps = Data.PageSpecific.BlogTag;
interface BlogTagsComponentProps extends BlogTagsProps {
  rendering: ComponentRendering;
  params?: { DynamicPlaceholderId?: string };
}

const BlogTags = (_props: BlogTagsComponentProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const contextWithSettings = sitecoreContext?.route;
  const tags = contextWithSettings?.fields?.blogTags as BlogTagsProps[];
  const siteSettingsField = sitecoreContext?.siteSettings as TransformedSiteSettings;
  const blogSearchPage = siteSettingsField?.blogSearchPage as LinkField;
  const { getDictionaryValue } = useDictionary();

  const { DynamicPlaceholderId } = _props?.params || {};
  const phKey = `socialsharelinks-${DynamicPlaceholderId}`;

  return (
    <div className="max-w-screen-xxl mx-auto px-10 lg:px-[80px] lg:flex justify-between pb-[48px] gap-[24px] w-full">
      <div className="pb-[24px] lg:pb-0">
        <div className="font-bold text-14 leading-22 font-nunitoSans text-gray-900 pb-4">
          {getDictionaryValue('TagsLabel')}:
        </div>
        <ul className="flex gap-4 flex-wrap">
          {tags?.map((tag: BlogTagsProps, index: number) => {
            return (
              <li key={index} className="flex items-center gap-2 ">
                <Link
                  href={`${blogSearchPage?.value?.href}?blogtag=${tag?.fields?.displayName?.value}`}
                  className="!text-blue-base w-fit flex-row theme-text-btn border-theme-text-btn-border lg:flex inline font-bold font-centuryGothic gap-x-4 items-center justify-center  !text-18 !leading-25 rounded-sm lg:text-center text-left text-theme-text-btn-text active:bg-theme-text-btn-hover active:text-theme-text-btn-hover-text active:border-theme-text-btn-hover-border  focus:outline-offset-2 focus:outline-2 focus:outline-theme-text-btn-outline focus:border-theme-text-btn-border focus:outline hover:!text-darkblue-base pb-2"
                >
                  {tag?.fields?.displayName?.value}
                  {index < tags.length - 1 ? ',' : ''}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <div>
        <PlaceholderWrapper name={phKey} rendering={_props.rendering} />
      </div>
    </div>
  );
};

export default BlogTags;
